import EditTable from './edit-table'
EditTable.install = function (Vue) {
  Vue.component(EditTable.name, EditTable)
}
export default EditTable
